<template>
  <li class="folder-data__item apollo" :class="{ hidden: hideIfFiltered }">
    <div
      class="folder-item"
      :class="{
        'folder-item--active': checked,
      }"
    >
      <div class="row m-0 items-center">
        <div class="col-auto">
          <div class="folder-item__checkbox flex ml-4" v-show="selectMode">
            <CheckboxVue
              :id="_id"
              :name="subpath"
              type="checkbox"
              v-model="checkModel"
            />
          </div>
        </div>

        <div class="col-1/x ml-4">
          <div
            style="min-height: 67px"
            class="flex flex-wrap flex-row items-center p-0 py-4"
            @mouseover="hoverActions = true"
            @mouseleave="hoverActions = false"
          >
            <router-link
              :to="path"
              class="flex lg:w-3/5 flex-wrap items-center m-0"
            >
              <div
                class="folder-item__icon w-5 h-auto inline-block"
                v-if="__typename"
              >
                <component :is="`Icon${__typename}`" />
              </div>
              <div class="folder-item__name px-3 font-medium">
                <span class="text-sans-base">{{ name }}</span>
              </div>
              <div class="folder-item__status" v-if="isPodcast && !publishedAt">
                <span class="chip">Bozza</span>
              </div>
            </router-link>
            <div
              class="folder-item__status lg:w-2/5 inline-flex lg:justify-end pr-6"
              v-if="!selectMode"
            >
              <span v-show="hoverActions">
                <span
                  @click="renameModal"
                  class="p-2 text-gray-600 uppercase font-bold text-sm cursor-pointer"
                  ><IconEdit class="h-5 inline-block" />RINOMINA</span
                >
                <span
                  @click="cancel"
                  class="p-2 text-gray-600 uppercase font-bold text-sm cursor-pointer"
                  ><IconTrash class="h-5 inline-block" /> CANCELLA</span
                >
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Modal ref="renameModal">
      <div class="create-item pt-4 pr-8 pb-8 pl-8">
        Rinomina il seguente elemento da "<i>{{ name }}</i
        >" a:
        <div class="create-item__alert">
          <p class="alerts alerts-errors text-center" v-if="error">
            {{ error }}
          </p>
        </div>
        <FormGroup for="nameItem">
          <InputVue
            type="text"
            :name="_id"
            :id="_id"
            :placeholder="labelInput"
            v-model="renameName"
          ></InputVue>
        </FormGroup>
        <button
          type="submit"
          @click="rename"
          slot="footer"
          class="p-4 btn-default"
        >
          Rinomina
          <slot></slot>
        </button>
      </div>
    </Modal>
  </li>
</template>

<script>
/** Components */
import CheckboxVue from '@/components/fields/CheckboxVue.vue'
import Modal from '@/components/Modal.vue'
import FormGroup from '@/components/FormGroup.vue'
import InputVue from '@/components/fields/InputVue.vue'

/** GraphQL */
import DELETE_PODCAST from '@/graphql/DeletePodcast.gql'
import DELETE_FOLDER from '@/graphql/DeleteFolder.gql'
import UPDATE_PODCAST from '@/graphql/UpdatePodcastName.gql'
import UPDATE_FOLDER from '@/graphql/UpdateFolderName.gql'

/** Icons */
import IconTrash from '@/assets/icons/icon-trash.svg'
import IconFolder from '@/assets/icons/icon-folder.svg'
import IconPodcast from '@/assets/icons/icon-podcast.svg'
import IconEdit from '@/assets/icons/icon-edit.svg'

export default {
  components: {
    Modal,
    FormGroup,
    InputVue,
    IconTrash,
    IconFolder,
    CheckboxVue,
    IconPodcast,
    IconEdit,
  },

  props: {
    __typename: {
      type: String,
      default: '',
    },

    _id: {
      type: String,
      default: '',
    },

    _ts: {
      type: Number,
      default: 0,
    },

    createdAt: {
      type: Number,
      default: 0,
    },

    name: {
      type: String,
      default: '',
    },

    publishedAt: {
      type: Number,
      default: 0,
    },

    filter: {
      type: String,
      default: '',
    },

    checked: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hoverActions: false,
      renameName: '',
      error: '',
    }
  },
  methods: {
    renameModal() {
      this.renameName = this.name
      this.$refs.renameModal.open()
    },
    rename() {
      this.error = ''
      if (this.renameName !== '') {
        let mutationQuery = UPDATE_PODCAST
        if (this.subpath === 'folders') {
          mutationQuery = UPDATE_FOLDER
        }
        this.$apollo
          .mutate({
            mutation: mutationQuery,
            variables: { id: this._id, newName: this.renameName },
          })
          .then(() => {
            this.$refs.renameModal.close()
            this.$parent.$parent.reloadFolder()
          })
          .catch(err => {
            if (err) {
              this.error =
                'Nome già utilizzato in questa cartella utilizzane un altro'
            }
          })
      } else {
        this.error = 'Il nuovo nome non può essere vuoto! '
      }
    },
    cancel() {
      if (confirm("Cancellare l'elemento selezionato?")) {
        let mutationQuery = DELETE_PODCAST
        if (this.subpath === 'folders') {
          mutationQuery = DELETE_FOLDER
        }
        this.$apollo
          .mutate({
            mutation: mutationQuery,
            variables: { id: this._id },
          })
          .then(() => {
            this.$parent.$parent.reloadFolder()
          })
      }
    },
  },
  computed: {
    subpath() {
      return this.__typename === 'Folder' ? 'folders' : 'podcasts'
    },
    labelInput() {
      return (
        'Inserisci qui il nuovo nome ' +
        (this.__typename === 'Folder' ? 'della cartella' : 'del visual podcast')
      )
    },
    path() {
      return {
        name: this.__typename === 'Folder' ? 'Folders' : 'PodcastsSectionRoot',
        params: {
          tenant: this.$route.params.tenant,
          id: this._id,
        },
      }
    },
    hideIfFiltered() {
      if (!this.filter || !this.isPodcast) {
        return false
      }

      switch (this.filter) {
        case 'draft':
          return !!this.publishedAt
        case 'publish':
          return !this.publishedAt
        default:
          return false
      }
    },
    isPodcast() {
      return this.__typename === 'Podcast'
    },
    selectMode() {
      return this.$store.state.folders.selectMode
    },
    checkModel: {
      get() {
        return this.checked
      },
      set(checked) {
        this.$emit('check', checked)
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.folder-item {
  @include m(active) {
    @apply bg-gray-200;
  }
}

.folder-item {
  @include e(icon) {
    svg {
      @apply w-full;
    }
  }
}
</style>
